import { services } from '../../config/services';
import { ServiceCard } from '../services/ServiceCard';
import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';

export function ServicesSection() {
  return (
    <section className="section services" id="services">
      <div className="shell">
        <Reveal><SectionHeading
          eyebrow="Services"
          title="Choose the website product that matches the business need."
          text="Each service has its own scope, starting point and project route. The homepage stays focused on helping you choose the right direction."
        /></Reveal>
        <Reveal delay={0.06}><div className="home-services-grid">
          {services.map((service) => <ServiceCard key={service.slug} service={service} />)}
        </div></Reveal>
      </div>
    </section>
  );
}
